import React, { Component } from "react";
import { DefaultSection, PaletteSection, PaletteSide } from "./PaletteSide";

class AddNewPalette extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPalette: "elements",
    };
  }

  render() {
    return (
      <div className="add-new">
        <div className="tabs-side">
          <h1>Add New</h1>
          <ul>
            <li
              onClick={() => this.setState({ currentPalette: "blocks" })}
              className={this.state.currentPalette === "blocks" ? "active" : ""}
            >
              Blocks
            </li>
            <li
              onClick={() => this.setState({ currentPalette: "elements" })}
              className={
                this.state.currentPalette === "elements" ? "active" : ""
              }
            >
              Elements
            </li>
          </ul>
        </div>
        <div className="content-side">
          {this.props.palettes.map((palette, index) => {
            return (
              <PaletteSide
                key={index}
                title={palette.sideTitle}
                paletteId={palette.id}
                currentPaletteId={this.state.currentPalette}
                closeEvent={() => {
                  this.props.onClose();
                }}
              >
                {palette.id === "blocks" && (
                  <PaletteSection
                    block={true}
                    tabs={palette.tabs}
                    currentPage={this.props.currentPage}
                    closeEvent={this.props.closeEvent}
                  />
                )}
                {palette.id === "elements" && (
                  <PaletteSection
                    tabs={palette.tabs}
                    currentPage={this.props.currentPage}
                    closeEvent={this.props.closeEvent}
                  />
                )}
              </PaletteSide>
            );
          })}
        </div>
      </div>
    );
  }
}

export default AddNewPalette;
